import React from 'react';
import './error-page.css';
export const ErrorPage = () => {
    return (React.createElement("div", { className: "error__container" },
        React.createElement("span", null, "Something Went Wrong")));
};
